.dialog {
  border: none;
  background: transparent;
  padding: 0;
  margin: auto;
  color: inherit;
  /* Scale with the display like the rest of the app. Width is
   * zoom-aware (92vw / scale) so the zoomed dialog never overflows a
   * narrow/tall window; no-op at 1080p. */
  width: min(520px, calc(92vw / var(--ui-scale)));
  overflow: visible;
  zoom: var(--ui-scale);
}

/* Wide variant — fixed-ish wide card (kept for any non-catalog wide use). */
.dialogWide {
  width: min(1500px, calc(95vw / var(--ui-scale)));
}

/* Content-hugging variant for catalog grids (Theme Store, Page Store).
 * The grid sets an explicit --cols from its item count, so the dialog
 * width adapts to how many items there are — narrow for one, capped for
 * many — instead of a fixed giant box. */
.dialogFit {
  width: fit-content;
  max-width: min(1500px, calc(95vw / var(--ui-scale)));
}

.dialog::backdrop {
  background: rgba(8, 18, 12, 0.55);
  backdrop-filter: blur(4px) saturate(120%);
  -webkit-backdrop-filter: blur(4px) saturate(120%);
}

.card {
  padding: 24px 26px 22px;
  font-family: var(--token-font-body);
  color: var(--token-text-primary);
  /* Never taller than the viewport — a large catalog scrolls inside the
   * card rather than overflowing off-screen. (zoom-aware: visual height
   * resolves to ~92vh.) */
  max-height: calc(92vh / var(--ui-scale));
  overflow-y: auto;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.title {
  margin: 0;
  font-family: var(--token-font-display);
  font-size: 24px;
  letter-spacing: 0.2px;
  color: var(--token-text-primary);
}

.description {
  margin: 4px 0 0;
  font-size: 14px;
  color: rgba(28, 38, 32, 0.78);
  /* Wrap rather than forcing a content-hugging (fit) dialog wide. */
  max-width: 52ch;
}

.close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  border: 1px solid rgba(8, 18, 12, 0.12);
  background: rgba(255, 255, 255, 0.4);
  color: rgba(28, 38, 32, 0.78);
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background 120ms ease,
    color 120ms ease;
}

.close:hover {
  background: rgba(255, 255, 255, 0.65);
  color: var(--token-text-primary);
}

.body {
  display: block;
}
